import "./index.less"

import { getLifeActivityNodeTime, getLifeActivityRank, } from '@utils/api.js'
import { cookie } from '@utils/index.js'

var _receiveInstance = (function () {
    const globalData = {
        isSign: "",
        cr: "",
        shopId: "",
        authorization: "",

        isOpenBlank: false,
        isLifeIconImg: false,
        lifeIconImg: "",
        lifeIconText: "",
        lifeUserTabText: "",
        lifeUserTabLink: "",

        isLifeActivityIconImg: false,
        lifeActivityIconImg: "",
        lifeActivityIconText: "",
    };
    const setGlobalData = async ({ isSign, cr, shopId, authorization, isOpenBlank, isLifeIconImg, lifeIconImg, isLifeActivityIconImg, lifeActivityIconImg, lifeIconText, lifeActivityIconText, lifeUserTabText, lifeUserTabLink, }) => {
        globalData.isSign = isSign;
        globalData.cr = cr;
        globalData.shopId = shopId;
        globalData.authorization = authorization;

        globalData.isOpenBlank = isOpenBlank
        globalData.isLifeIconImg = isLifeIconImg
        globalData.lifeIconImg = lifeIconImg
        globalData.lifeIconText = lifeIconText
        globalData.lifeUserTabText = lifeUserTabText
        globalData.lifeUserTabLink = lifeUserTabLink

        globalData.isLifeActivityIconImg = isLifeActivityIconImg
        globalData.lifeActivityIconImg = lifeActivityIconImg
        globalData.lifeActivityIconText = lifeActivityIconText
    };
    const getGlobalData = () => {
        return JSON.parse(JSON.stringify(globalData));
    };
    class ReceiveJackeryLife {
        constructor(el) {
            this.init(el);
        }
        init(el) {
            setGlobalData(el);
        }
    }
    // 悬浮 icon
    class FixedIcon {
        constructor() {
          if (globalData?.isLifeActivityIconImg) {
            this.createDOM()
          }
        }
        // 创建悬浮 icon
        createDOM() {
          const oDiv = document.createElement('div')
          oDiv.style.display = 'none'
          oDiv.className = 'flex flex-col fixed z-2000 right-16 top-[40%] lg:j-right-32 xl:a-right-32'
          oDiv.innerHTML = `
            <div class="life-user-icon relative z-2000" data-life-activity-user-icon>
              <div class="life-user-icon-tips">
                <span class="font-semibold text-#333 line-clamp-2"></span>
              </div>
            </div>
          `
    
          document.body.appendChild(oDiv)
    
          // 初始化事件
          this.init()
        }
        init() {
          this.fixedIcon = document.querySelector('[data-life-activity-user-icon]')
          if (!this.fixedIcon) return
    
          this.fixedIcon.parentElement.style.display = 'block'
    
          this.fixedIcon.style.background = `url(${globalData?.lifeActivityIconImg}) center center / contain no-repeat`
    
          const tipsDOM = this.fixedIcon.querySelector('.life-user-icon-tips')
          if (globalData?.lifeActivityIconText) {
            tipsDOM.querySelector('span').innerHTML = globalData?.lifeActivityIconText
    
            this.fixedIcon.addEventListener('mouseenter', () => tipsDOM.classList.add('active'))
            this.fixedIcon.addEventListener('mouseleave', () => tipsDOM.classList.remove('active'))
          }
    
          this.handleClick()
        }
        // 处理 click 事件
        handleClick() {
          this.fixedIcon.onclick = () => {
            // 已登录
            if (globalData?.isSign) {
              window.open(`${location.origin}/pages/life-user?curUser=true`, '_blank')
            }
            // 未登录
            else {
              window?.jackeryLoginApp.modalLogin({
                register_act: 'JL-register',
                return_url: `${window.location.origin}/pages/life-user?curUser=true`
              })
            }
          }
        }
    }
    return {
        ReceiveJackeryLife,
        FixedIcon,
        getGlobalData,
    };
})();


class BaseSwiper {
    constructor() {

    }
    $$(entity) {
        return entity ? document.querySelector(entity) : null
    }
    isMobile() {
        return document.documentElement.clientWidth < 1024
    }
    // 首字母大写
    upperFirst(str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }
    // 补零
    padZero(number, length = 2) {
        let str = number.toString()
        while (str.length < length) {
            str = '0' + str
        }
        return str
    }
}


// 活动 Benifits
class ActivityBenefits extends BaseSwiper {
    constructor({ swiperContainerPC, swiperPaginationPC, swiperContainerMB, swiperPaginationMB, ...props }) {
        super(props)

        const swiperContainerPCDOM = document.querySelector(swiperContainerPC)
        const swiperPaginationPCDOM = document.querySelector(swiperPaginationPC)
        swiperContainerPCDOM && swiperPaginationPCDOM && this.initPC(swiperContainerPC, swiperPaginationPC)

        const swiperContainerMBDOM = document.querySelector(swiperContainerMB)
        const swiperPaginationMBDOM = document.querySelector(swiperPaginationMB)
        swiperContainerMBDOM && swiperPaginationMBDOM && this.initMB(swiperContainerMB, swiperPaginationMB)
    }
    initPC(swiperContainerPC, swiperPaginationPC) {
        // 示例
        new Swiper(swiperContainerPC, {
            centeredSlides: true,
            initialSlide: 0,
            spaceBetween: -400,
            effect: "coverflow",
            grabCursor: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 200,
                modifier: 4,
                slideShadows: true,
                scale: 1,
            },
            pagination: {
                el: swiperPaginationPC,
                clickable: true,
                bulletClass: 'benefit-pagination-pc-item',
                bulletActiveClass: 'benefit-pagination-pc-item-active',
                clickableClass: 'benefit-pagination-pc-item-clickable',
                modifierClass: 'benefit-pagination-pc-',
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`
                },
            },
            navigation: {
                nextEl: '.benefit-pc-button-next',
                prevEl: '.benefit-pc-button-prev',
            },
        });
    }
    initMB(swiperContainerMB, swiperPaginationMB) {
        new Swiper(swiperContainerMB, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            autoplay: false,
            pagination: {
                el: swiperPaginationMB,
                clickable: true,
                bulletClass: 'benefit-pagination-mb-item',
                bulletActiveClass: 'benefit-pagination-mb-item-active',
                clickableClass: 'benefit-pagination-mb-item-clickable',
                modifierClass: 'benefit-pagination-mb-',
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`
                },
            },
            on: {
                resize: function () {
                    setTimeout(() => {
                        this.update()
                    }, 600);
                }
            },
        })
    }
}

// 活动 Process
class ActivityProcess extends BaseSwiper {
    constructor({ swiperContainer, swiperPagination, ...props }) {
        super(props)

        this.swiperContainer = swiperContainer
        this.swiperPagination = swiperPagination

        const swiperContainerDOM = document.querySelector(swiperContainer)
        const swiperPaginationDOM = document.querySelector(swiperContainer)

        swiperContainerDOM && swiperPaginationDOM && this.init()
    }
    init() {
        new Swiper(this.swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            autoplay: false,
            pagination: {
                el: this.swiperPagination,
                clickable: true,
                bulletClass: 'life-activity-process-pagination-item',
                bulletActiveClass: 'life-activity-process-pagination-item-active',
                clickableClass: 'life-activity-process-pagination-item-clickable',
                modifierClass: 'life-activity-process-pagination-',
                renderBullet: function (index, className) {
                    return `<span class="${className}">${index + 1}</span>`
                },
            },
            on: {
                resize: function () {
                    setTimeout(() => {
                        this.update()
                    }, 600);
                }
            },
        })
    }
}

// 无缝滚动
class SeamlessScroll extends BaseSwiper {
    constructor({ swiperContainer, ...props }) {
        super(props)

        const swiperContainerDOM = document.querySelector(swiperContainer)

        swiperContainerDOM && this.init(swiperContainer)
    }
    init(swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            speed: 5000, // 滚动速度
            loop: true,
            // loopAdditionalSlides: 4,
            autoplay: {
                delay: 1,
                disableOnInteraction: false, //就算触摸了也继续滚动
            },
            on: {
                click: function (swiper, e) {
                    if (e.target.parentElement?.href) {
                        window.location.href = e.target.parentElement.href
                    }
                    return false
                },
                resize: function () {
                    setTimeout(() => {
                        this.update()
                    }, 600);
                }
            }
        })
    }
}

// 活动节点时间
class ActivityNodeTime {
    constructor({ el, }) {
        this.DOM = document.querySelector(el)

        this.DOM && this.init()
    }
    async init() {
        const shopifyActivityId = getUrlQueryParams('shopifyActivityId')
        try {
            const { data, } = await getLifeActivityNodeTime({ shopifyActivityId, })
            const length = data?.activitNodeList?.length
            const html = this.renderStepNode(data?.activitNodeList, length)

            if (length === 4) {
                this.DOM?.classList?.add('grid-cols-4')
            }

            this.DOM.innerHTML = html
        } catch {
            this.DOM.innerHTML = ''
        }
    }
    renderStepNode(list = [], listLength) {
        let html = ''
        list.forEach(({ showNode, title, nodeTime, fileUrl, }) => {
            html += `
                <li class="flex-center flex-col px-20 lg:j-px-20 xl:a-px-20 registration-step-${listLength} ${showNode ? 'active' : ''}">
                    <img
                        loading="lazy"
                        class="w-80 h-80 lg:j-w-80 lg:j-h-80 xl:a-w-80 xl:a-h-80 object-contain ${showNode ? '' : 'grayscale'}"
                        src="${fileUrl}"
                        alt=""
                    >
                    <h3
                        class="
                            text-22 leading-32 h-64 mt-32 mb-20 text-#333 flex-start text-center font-semibold line-clamp-2
                            lg:j-text-22 lg:j-leading-32 lg:h-auto lg:j-mt-48 lg:j-mb-20
                            xl:a-text-22 xl:a-leading-32 xl:h-auto xl:a-mt-48 xl:a-mb-20
                        "
                        title="${title}"
                    >${title}</h3>
                    <p class="text-20 leading-28 text-#666 font-medium lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24">${nodeTime.slice(0, 10)}</p>
                </li>
            `
        })

        return html
    }
}

// jackery-life 活动 Share
class ActivityShare {
    constructor({ el }) {
        this.DOMs = document.querySelectorAll(el)

        this.DOMs.length && this.init()
    }
    init() {
        this.DOMs.forEach(it => {
            it.onclick = () => {
                const link = it.dataset.link
                const searchParams = window.location.search
                const decodeParams = decodeURIComponent(searchParams)
                const params = new URLSearchParams(decodeParams)
                const shopifyActivityId = params.get('shopifyActivityId')

                if (link) {
                    if (link.includes('?')) {
                        window.open(`${link}`, "_self")
                    } else {
                        window.open(`${link}?shopifyActivityId=${shopifyActivityId}`, "_self")
                    }
                }
            }
        })
    }
}


// 排行榜
class Rank extends BaseSwiper {
    constructor(props) {
        super(props)

        this.tabWrap = this.$$('[data-tab-wrap]')
        this.rankStatisticTimeDOM = this.$$('[data-rank-statistic-time]')
        this.rankEffectiveTimeDOM = this.$$('[data-rank-effective-time]')

        this.rankFirstDOM = this.$$('[data-rank-first]')
        this.rankSecondDOM = this.$$('[data-rank-second]')
        this.rankThirdDOM = this.$$('[data-rank-third]')

        this.rankTableHeader = this.$$('[data-rank-table-header]')
        this.rankTableContent = this.$$('[data-rank-table-content]')

        this.rankTipsDOM = this.$$('[data-rank-tips]')
        this.noDataDOM = this.$$('[data-no-data]')

        this.rankBaseTable = ['Number', 'Username']
        this.rankTableTitle = []

        this.init()
    }
    async init() {
        try {
            this.renderSkeleton()

            const shopifyActivityId = getUrlQueryParams('shopifyActivityId') || ''
            const authorization = window._receiveInstance?.getGlobalData()?.authorization || cookie.get("_jk_user")
            const { data = [] } = await getLifeActivityRank({ shopifyActivityId, }, { headers: { authorization, } })

            if (data && data.length) {
                this.rankData = data.filter(({ chartsDataList, }) => chartsDataList.length > 0)

                if (this.rankData.length) {
                    let tabHTML = ''
                    this.rankData.forEach(({ chartsTitleName, }, index) => {
                        tabHTML += this.renderRankTab(chartsTitleName, index)
                    })
                    this.tabWrap.innerHTML = tabHTML


                    this.tabs = this.tabWrap.querySelectorAll('[data-tab]')
                    this.tabs.forEach((item, index) => item.onclick = () => this.handleClick(item, index))

                    // 默认渲染第一个
                    this.renderRank(this.rankData[0])
                }
                // 无数据
                else {
                    this.renderRankNoData()
                }
            }
            // 无数据
            else {
                this.renderRankNoData()
            }
        } catch {
            // 无数据 兜底
            this.renderRankNoData()
        }
    }
    // 渲染榜单
    renderRank({
        refreshTimeStr,
        statisticsType,
        customTitle = 'Points',
        creationShow,
        currentUserUpload,
        currentUserNum,
        currentUserPreviousNum,
        chartsDataList = [],
        chartsStartTimeStr,
        chartsEndTimeStr,
    }) {
        this.rankStatisticTimeDOM.innerHTML = `Data statistics to ${refreshTimeStr}`
        this.rankEffectiveTimeDOM.innerHTML = `${chartsStartTimeStr.split(' ')[0]} - ${chartsEndTimeStr.split(' ')[0]}`

        // 渲染榜单数据
        if (chartsDataList && chartsDataList.length) {
            if (statisticsType === 1) {
                // 作品名称
                this.rankTableTitle = creationShow ? this.rankBaseTable.concat(['Title']) : this.rankBaseTable

                // 自定义分值名称
                this.rankTableTitle = this.rankTableTitle.concat([customTitle])
            } else {
                // 个人中心链接
                this.rankTableTitle = creationShow ? this.rankBaseTable.concat(['Link']) : this.rankBaseTable

                // 作品数量
                this.rankTableTitle = this.rankTableTitle.concat(['Works'])
            }
            this.rankTableHeader.innerHTML = this.renderRankTableHeader()

            // 渲染 1-3 名，4-100 名
            const [firstRank, secondRank, thirdRank, ...rest] = chartsDataList
            this.renderRankTopThree(statisticsType, creationShow, [firstRank, secondRank, thirdRank])
            this.rankTableContent.innerHTML = this.renderRankRest(statisticsType, creationShow, rest)

            // 渲染榜单提示
            this.renderRankTips(currentUserUpload, currentUserNum, currentUserPreviousNum)
        }
        // 无数据
        else {
            this.renderRankNoData()
        }
    }
    // 渲染榜单 Tab
    renderRankTab(chartsTitleName, index) {
        return `
            <li
                class="
                    rank-tab ${index === 0 ? 'active' : ''} flex-shrink-0 flex-center text-center font-bold text-white cursor-pointer
                    w-306 h-81 px-24 py-16
                    lg:j-w-306 lg:j-h-81 lg:j-px-24 lg:j-pt-10 lg:j-pb-14
                    xl:a-w-306 xl:a-h-81 xl:a-px-24 xl:a-pt-10 xl:a-pb-14
                "
                data-tab
            >
                <span class="line-clamp-2 text-26 leading-28 lg:j-text-20 lg:j-leading-26 xl:a-text-20 xl:a-leading-26">
                    ${chartsTitleName}
                </span>
            </li>
        `
    }
    // 渲染榜单 1-2-3 名
    renderRankTopThree(statisticsType, creationShow, data) {
        const rankTopDOMs = [this.rankFirstDOM, this.rankSecondDOM, this.rankThirdDOM]

        // 渲染片段
        const renderSnippets = ({ userName, statisticsTotal, chartsName, chartsUrlId, userId, }) => {
            return `
                <h3
                    class="
                        font-semibold text-#333 text-28 leading-28
                        lg:j-text-20 lg:j-leading-20
                        xl:a-text-20 xl:a-leading-20
                    "
                >${userName}</h3>
                ${statisticsType === 1
                    ?
                    creationShow
                        ?
                            `
                                <a
                                    href="/pages/life-detail?creationId=${chartsUrlId}&jfFrom=explore"
                                    class="w-full font-medium text-#333 underline transition-all duration-300 hover:text-primary"
                                >
                                    <span class="line-clamp-1 text-center text-26 leading-36 lg:j-text-16 lg:j-leading-20 xl:a-text-16 xl:a-leading-20">
                                        ${chartsName || chartsUrlId}
                                    </span>
                                </a>
                            `
                        : ''
                    :
                    creationShow
                        ?
                            `
                                <a
                                    href="/pages/life-user?uid=${userId}"
                                    class="w-full font-medium text-#333 underline transition-all duration-300 hover:text-primary"
                                >
                                    <span class="line-clamp-1 text-center text-26 leading-36 lg:j-text-16 lg:j-leading-20 xl:a-text-16 xl:a-leading-20">
                                        ${location.origin}/pages/life-user?uid=${userId}
                                    </span>
                                </a>
                            `
                        : ''
                }
                <p
                    class="
                        font-semibold text-primary text-28 leading-28 mt-12
                        lg:j-text-18 lg:j-leading-18 lg:j-mt-0 xl:a-text-18 xl:a-leading-18 xl:a-mt-0
                    "
                >${statisticsTotal}</p>
            `
        }

        data.forEach((it, index) => rankTopDOMs[index].innerHTML = renderSnippets(it))
    }
    // 渲染榜单 table header
    renderRankTableHeader() {
        let html = ''
        const length = this.rankTableTitle.length
        this.rankTableTitle.forEach((it, idx) => {
            let name = it.split(' ').map(t => this.upperFirst(t)).join(' ')
            html += `
                <span class="rank-table-title ${length > 3 && idx === 2 ? 'rank-fixed-width' : ''}">${name}</span>
            `
        })
        return html
    }
    // 渲染榜单 table（4-100名）
    renderRankRest(statisticsType, creationShow, data) {
        let html = ''
        data.forEach(({ userName, statisticsTotal, chartsName, chartsUrlId, userId, }, index) => {
            html += `
                <li class="flex-between h-88 gap-x-25 lg:j-h-48 lg:j-gap-x-25 xl:a-h-48 xl:a-gap-x-25">
                    <span class="rank-table-item">${this.padZero(index + 4)}</span>
                    <span class="rank-table-item">${userName}</span>
                    ${statisticsType === 1
                    ?
                    creationShow
                        ?
                            `
                                <span class="rank-table-item rank-fixed-width">
                                    <a
                                        href="/pages/life-detail?creationId=${chartsUrlId}&jfFrom=explore"
                                        class="font-medium line-clamp-1 underline text-#666 lg:text-#333 transition-all duration-300 hover:text-primary"
                                    >${chartsName || chartsUrlId}</a>
                                </span>
                            `
                        : ''
                    :
                    creationShow
                        ?
                            `
                                <span class="rank-table-item rank-fixed-width">
                                    <a
                                        href="/pages/life-user?uid=${userId}"
                                        class="font-medium underline text-#666 lg:text-#333 transition-all duration-300 hover:text-primary"
                                    >
                                        <span class="line-clamp-1 text-center text-26 leading-36 lg:j-text-16 lg:j-leading-20 xl:a-text-16 xl:a-leading-20">
                                            ${location.origin}/pages/life-user?uid=${userId}
                                        </span>
                                    </a>
                                </span>
                            `
                        : ''
                }
                    <span class="rank-table-item">${statisticsTotal}</span>
                </li>
            `
        })
        return html
    }
    // 渲染榜单提示信息
    renderRankTips(currentUserUpload, currentUserNum, currentUserPreviousNum) {
        this.rankTipsDOM?.classList?.remove('hidden')

        const html = !window?.pageInfo?.customerInfo?.id
            ?
                `
                    <p class="line-clamp-2 text-28 leading-36 lg:j-text-16 lg:j-leading-20 xl:a-text-16 xl:a-leading-20">
                        Log in to your account to view your current rankings.
                    </p>
                `
            : currentUserUpload
                ?
                    `
                        <p class="line-clamp-2 text-28 leading-36 lg:j-text-16 lg:j-leading-20 xl:a-text-16 xl:a-leading-20">
                            Your ranking is ${currentUserNum}. In case of a tie, those who registered first will be given priority.
                        </p>
                    `
                :
                    `
                        <p class="line-clamp-2 text-28 leading-36 lg:j-text-16 lg:j-leading-20 xl:a-text-16 xl:a-leading-20">
                            Haven't participated in the event yet? Share your wonderful life now!
                        </p>
                    `
        this.rankTipsDOM.innerHTML = html
    }
    // 渲染无数据
    renderRankNoData() {
        this.rankTableHeader?.classList?.add('hidden')
        this.rankTableContent?.classList?.add('hidden')
        this.rankTipsDOM?.classList?.add('hidden')

        this.noDataDOM?.classList?.remove('hidden')

        // tab 骨架
        this.tabWrap && (
            this.tabWrap.innerHTML = '<div class="bg-transparent w-300 h-81 lg:j-w-300 lg:j-h-81 xl:a-w-300 xl:a-h-81"></div>'
        )
        // 有效时间骨架
        this.rankEffectiveTimeDOM && (
            this.rankEffectiveTimeDOM.innerHTML = '<div class="bg-transparent w-300 h-24 lg:j-w-300 lg:j-h-24 xl:a-w-300 xl:a-h-24"></div>'
        )

        // 1-2-3 名骨架
        this.rankFirstDOM && (this.rankFirstDOM.innerHTML = '')
        this.rankSecondDOM && (this.rankSecondDOM.innerHTML = '')
        this.rankThirdDOM && (this.rankThirdDOM.innerHTML = '')
    }
    // 渲染骨架屏
    renderSkeleton() {
        // tab 骨架
        this.tabWrap && (
            this.tabWrap.innerHTML = `
                <li class="skeleton bg-[#EEE]/50 mx-6 lg:j-mx-6 xl:a-mx-6 w-300 h-81 lg:j-w-300 lg:j-h-70 xl:a-w-300 xl:a-h-70"></li>
                <li class="skeleton bg-[#EEE]/50 mx-6 lg:j-mx-6 xl:a-mx-6 w-300 h-81 lg:j-w-300 lg:j-h-70 xl:a-w-300 xl:a-h-70"></li>
            `
        )
        // 有效时间骨架
        this.rankEffectiveTimeDOM && (
            this.rankEffectiveTimeDOM.innerHTML = `
                <p class="mx-auto skeleton bg-[#EEE]/50 mx-6 lg:j-mx-6 xl:a-mx-6 w-300 h-24 lg:j-w-300 lg:j-h-24 xl:a-w-300 xl:a-h-24"></p>
            `
        )

        // 1-2-3 名骨架
        this.rankFirstDOM && (
            this.rankFirstDOM.innerHTML = `
                <div class="skeleton bg-[#EEE]/50 w-65 h-28 lg:j-w-65 lg:j-h-20 xl:a-w-65 xl:a-h-20"></div>
                <div class="skeleton bg-[#EEE]/50 w-130 h-28 lg:j-w-130 lg:j-h-20 xl:a-w-130 xl:a-h-20"></div>
                <div class="skeleton bg-[#EEE]/50 w-65 h-28 lg:j-w-65 lg:j-h-20 xl:a-w-65 xl:a-h-20"></div>
            `
        )
        this.rankSecondDOM && (
            this.rankSecondDOM.innerHTML = `
                <div class="skeleton bg-[#EEE]/50 w-65 h-28 lg:j-w-65 lg:j-h-20 xl:a-w-65 xl:a-h-20"></div>
                <div class="skeleton bg-[#EEE]/50 w-130 h-28 lg:j-w-130 lg:j-h-20 xl:a-w-130 xl:a-h-20"></div>
                <div class="skeleton bg-[#EEE]/50 w-65 h-28 lg:j-w-65 lg:j-h-20 xl:a-w-65 xl:a-h-20"></div>
            `
        )
        this.rankThirdDOM && (
            this.rankThirdDOM.innerHTML = `
                <div class="skeleton bg-[#EEE]/50 w-65 h-28 lg:j-w-65 lg:j-h-20 xl:a-w-65 xl:a-h-20"></div>
                <div class="skeleton bg-[#EEE]/50 w-130 h-28 lg:j-w-130 lg:j-h-20 xl:a-w-130 xl:a-h-20"></div>
                <div class="skeleton bg-[#EEE]/50 w-65 h-28 lg:j-w-65 lg:j-h-20 xl:a-w-65 xl:a-h-20"></div>
            `
        )

        // rank-table-content 骨架
        this.rankTableContent && (
            this.rankTableContent.innerHTML = `
                <div class="w-full h-full flex-col -mt-88 -lg:j-mt-48 -xl:a-mt-48">
                    <div class="w-full skeleton bg-[#EEE]/50 h-88 my-88 lg:j-h-48 lg:j-my-48 xl:a-h-48 xl:a-my-48"></div>
                    <div class="w-full skeleton bg-[#EEE]/50 h-88 my-88 lg:j-h-48 lg:j-my-48 xl:a-h-48 xl:a-my-48"></div>
                    <div class="w-full skeleton bg-[#EEE]/50 h-88 my-88 lg:j-h-48 lg:j-my-48 xl:a-h-48 xl:a-my-48"></div>
                </div>
            `
        )
    }
    handleClick(item, index) {
        this.tabs.forEach(it => it?.classList?.remove('active'))
        item?.classList?.add('active')

        this.renderRank(this.rankData[index])

        const distance =
            index === 0
                ? 0
                : index === 1
                    ? (item.parentElement.offsetWidth - item.parentElement.parentElement.offsetWidth) / 2
                    : item.parentElement.offsetWidth - item.parentElement.parentElement.offsetWidth
        item.parentElement.style.transform = `translateX(-${distance}px)`
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const lifeActivityBanner = document.querySelector(".life-activity-banner")
    const { isLifeActivityIconImg, lifeActivityIconImg, lifeActivityIconText, } = lifeActivityBanner.dataset

    new _receiveInstance.ReceiveJackeryLife({
        ..._receiveInstance.getGlobalData(),

        isSign: !!window?.pageInfo?.customerInfo?.id,
        cr: Shopify.country,
        shopId: window.shopId,
        authorization: !!window?.pageInfo?.customerInfo?.id ? cookie.get("_jk_user") : '',

        isLifeActivityIconImg: isLifeActivityIconImg?.trim() === 'true',
        lifeActivityIconImg,
        lifeActivityIconText,
    })

    // 悬浮 icon
    new _receiveInstance.FixedIcon()

    // benefit
    new ActivityBenefits({
        swiperContainerPC: '.life-activity-benefit-pc',
        swiperPaginationPC: '.life-activity-benefit-pagination-pc',

        swiperContainerMB: '.life-activity-benefit-mb',
        swiperPaginationMB: '.life-activity-benefit-pagination-mb',
    })
    new ActivityProcess({
        swiperContainer: '.life-activity-process',
        swiperPagination: '.life-activity-process-pagination',
    })
    new SeamlessScroll({
        swiperContainer: '.life-activity-explore',
    })
    // 排行榜
    new Rank()

    new ActivityNodeTime({
        el: '[data-registration-wrap]',
    })

    new ActivityShare({ el: '[data-share-now]' })
})
